import { useState } from 'react';
import { FcaLookupService } from '@/features/b2b/register/services/fcaLookupService';

/**
 * Custom hook for FCA lookup functionality
 * Manages lookup state and API interactions
 */
export const useFcaLookup = (formData, handleSelectChange) => {
  const [lookupState, setLookupState] = useState('ready'); // ready, loading, done, error

  const handleFcaLookup = async () => {
    setLookupState('loading');
    handleSelectChange('fcaLookup')('loading'); // Sync with form data

    const fcaIdElement = document.getElementById('fcaId');

    if (fcaIdElement) {
      fcaIdElement.readOnly = true;
    }

    const result = await FcaLookupService.lookupFcaData(formData.fcaId);

    if (result.success) {
      // Update form data with FCA lookup results
      Object.entries(result.data).forEach(([key, value]) => {
        handleSelectChange(key)(value);
      });

      setLookupState('done');
      handleSelectChange('fcaLookup')('done'); // Sync with form data
    } else {
      setLookupState('error');
      handleSelectChange('fcaLookup')('error'); // Sync with form data

      if (fcaIdElement) {
        fcaIdElement.readOnly = false;
      }

      // Only log in development
      if (process.env.NODE_ENV === 'development') {
        console.error('FCA lookup failed:', result.error);
      }
    }
  };

  const handleFcaReset = () => {
    setLookupState('ready');
    handleSelectChange('fcaLookup')('ready'); // Sync with form data

    // Reset UI elements
    const fcaError = document.getElementById('fcaError');
    const fcaIdElement = document.getElementById('fcaId');

    if (fcaError) {
      fcaError.classList.add('hidden');
    }

    if (fcaIdElement) {
      fcaIdElement.readOnly = false;
    }

    // Reset form fields
    const fieldsToReset = [
      'fcaId', 'companyStatus', 'name', 'phone',
      'postcode', 'al1', 'al2', 'town', 'county',
    ];

    fieldsToReset.forEach(field => {
      handleSelectChange(field)('');
    });
  };

  const handleFcaIdChange = (e) => {
    // Format the input to only allow numeric characters
    const formattedValue = FcaLookupService.formatFcaId(e.target.value);

    // Update the input value
    e.target.value = formattedValue;

    // Call the original change handler
    return e;
  };

  return {
    lookupState,
    handleFcaLookup,
    handleFcaReset,
    handleFcaIdChange,
  };
};
